import { css } from "@emotion/react";
import React, { useState } from "react";

import { Modal, ModalPortal } from "@livechat/design-system-react-components";

import { EventPlace, trackEngagement } from "helpers/analytics";
import { StackingContextLevel } from "styles/stacking-context-level";

import { ConfirmExitModalContent } from "./ConfirmExitModalContent";
import { AddAgentsModalContent } from "./add-agents/AddAgentsModalContent";

interface IProps {
  onClose: () => void;
}

export const AddOrConfirmModal: React.FC<IProps> = ({ onClose }) => {
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const [confirmBeforeExiting, setConfirmBeforeExiting] = useState(false);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleClose = () => {
    if (confirmBeforeExiting) {
      setIsConfirmModalVisible(true);
    } else {
      onClose();
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const hideConfirmModal = () => {
    setIsConfirmModalVisible(false);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleCancel = () => {
    trackEngagement("Agents: Invitation modal closed with input", EventPlace.Agents, { decision: "Cancel" });
    onClose();
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleConfirm = () => {
    trackEngagement("Agents: Invitation modal closed with input", EventPlace.Agents, {
      decision: "Continue inviting",
    });
    hideConfirmModal();
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onConfirmBeforeExitingChange = (confirmBeforeExiting: boolean) => {
    setConfirmBeforeExiting(confirmBeforeExiting);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleXClick = (isConfirmModalVisible: boolean) => {
    if (isConfirmModalVisible) {
      trackEngagement("Agents: Invitation modal closed with input", EventPlace.Agents, {
        decision: "X",
      });
      hideConfirmModal();
    } else {
      handleClose();
    }
  };

  return (
    <ModalPortal zIndex={StackingContextLevel.Modal}>
      <Modal
        onClose={() => handleXClick(isConfirmModalVisible)}
        heading={!isConfirmModalVisible && <div data-testid="modal-heading">Invite agents</div>}
        closeOnOverlayPress={false}
        css={{
          width: isConfirmModalVisible ? "600px" : "768px",
          height: "auto",
        }}
      >
        <div
          css={css`
            display: ${isConfirmModalVisible ? "none" : "flex"};
          `}
        >
          <AddAgentsModalContent
            onModalClose={handleClose}
            onConfirmBeforeExitingChange={onConfirmBeforeExitingChange}
          />
        </div>
        <ConfirmExitModalContent onCancel={handleCancel} onConfirm={handleConfirm} isVisible={isConfirmModalVisible} />
      </Modal>
    </ModalPortal>
  );
};
